/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import {ContractDtoMeta, ContractListMeta, ContractListVO, ServiceProviderContractDTO} from '@well/domain';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContractResourceService extends AbstractResourceService<ContractListVO, ServiceProviderContractDTO, ContractListMeta, ContractDtoMeta> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('contractUrl'),
      ContractListVO,
      ServiceProviderContractDTO
    );
  }
}
